import React from 'react';

// Días en convención luxon (1 = lunes … 7 = domingo), igual que el backend.
const DIAS = [
  { n: 1, label: 'Lunes' },
  { n: 2, label: 'Martes' },
  { n: 3, label: 'Miércoles' },
  { n: 4, label: 'Jueves' },
  { n: 5, label: 'Viernes' },
  { n: 6, label: 'Sábado' },
  { n: 7, label: 'Domingo' }
];

const WhatsappSettingsModal = ({
  open,
  onClose,
  alertVariant,
  status,
  handleConnect,
  loadingWhatsApp,
  wabaToken,
  setWabaToken,
  phoneNumberId,
  setPhoneNumberId,
  wabaId,
  setWabaId,
  wabaVerifyToken,
  setWabaVerifyToken,
  autoReplyEnabled,
  setAutoReplyEnabled,
  autoReplyText,
  setAutoReplyText,
  autoReplyTemplateId,
  setAutoReplyTemplateId,
  autoReplyTemplateLang,
  setAutoReplyTemplateLang,
  autoReplyTemplateType,
  setAutoReplyTemplateType,
  whatsappTemplates,
  onSaveAutoReply,
  autoReplyOnceHours,
  setAutoReplyOnceHours,
  offHoursEnabled,
  setOffHoursEnabled,
  offHoursText,
  setOffHoursText,
  offHoursOnceHours,
  setOffHoursOnceHours,
  businessHours,
  setBusinessHours,
  onSaveOffHours,
  aiGenerateDraft,
  setAiGenerateDraft,
  aiAutoSend,
  setAiAutoSend,
  onSaveAiConfig
}) => {
  if (!open) return null;

  // ── Editor de horario comercial (tramos por día; admite turno partido) ──
  const dias = businessHours?.days || {};
  const ranges = (n) => (Array.isArray(dias[n]) ? dias[n] : []);
  const updateDay = (n, list) => setBusinessHours({
    timezone: businessHours?.timezone || 'Europe/Madrid',
    days: { ...dias, [n]: list }
  });
  const toggleDia = (n, abierto) => updateDay(n, abierto ? [{ from: '10:00', to: '19:00' }] : []);
  const setHora = (n, idx, campo, valor) => {
    const list = ranges(n).map((r, i) => (i === idx ? { ...r, [campo]: valor } : r));
    updateDay(n, list);
  };
  const addTramo = (n) => updateDay(n, [...ranges(n), { from: '16:00', to: '19:00' }]);
  const delTramo = (n, idx) => updateDay(n, ranges(n).filter((_r, i) => i !== idx));
  // Copiar la configuración del lunes al resto de días laborables (evita teclear 5 veces)
  const aplicarLunesALaborables = () => {
    const lunes = ranges(1).map((r) => ({ ...r }));
    const next = { ...dias };
    [2, 3, 4, 5].forEach((n) => { next[n] = lunes.map((r) => ({ ...r })); });
    setBusinessHours({ timezone: businessHours?.timezone || 'Europe/Madrid', days: next });
  };

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Configurar WhatsApp Business</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {status && (
              <div className={`alert alert-${alertVariant(status.type)}`}>
                {status.message}
              </div>
            )}
            <form onSubmit={handleConnect} className="mb-3">
              <div className="mb-3">
                <label className="form-label">Token de acceso</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="EAAG..."
                  value={wabaToken}
                  onChange={(e) => setWabaToken(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone Number ID</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej: 1234567890"
                  value={phoneNumberId}
                  onChange={(e) => setPhoneNumberId(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">WABA ID</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej: 1735064047189549"
                  value={wabaId}
                  onChange={(e) => setWabaId(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Verify Token (webhook)</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Frase secreta para validar webhook"
                  value={wabaVerifyToken}
                  onChange={(e) => setWabaVerifyToken(e.target.value)}
                />
                <div className="form-text">Usa el mismo valor en el panel de Meta.</div>
              </div>
              <button type="submit" className="btn btn-primary" disabled={loadingWhatsApp}>
                {loadingWhatsApp ? 'Conectando...' : 'Conectar WhatsApp Business'}
              </button>
            </form>
            <hr />
            <h6>Respuesta automática (saludo)</h6>
            <p className="text-muted small mb-2">
              Acuse de recibo que se envía <strong>una sola vez al inicio de la conversación</strong>, no en cada
              mensaje: si el cliente sigue escribiendo, no se repite. Vuelve a enviarse solo cuando el cliente
              retoma el contacto después del tiempo de espera de abajo. No se envía en las conversaciones que
              tengas con la respuesta automática desactivada en su panel de opciones.
            </p>
            <div className="form-check form-switch mb-2">
              <input className="form-check-input" type="checkbox" id="wabaAutoReply" checked={autoReplyEnabled} onChange={(e) => setAutoReplyEnabled(e.target.checked)} />
              <label className="form-check-label" htmlFor="wabaAutoReply">Activar respuesta automática</label>
            </div>
            <div className="mb-3">
              <textarea className="form-control" rows="3" value={autoReplyText} onChange={(e) => setAutoReplyText(e.target.value)} placeholder="Texto de respuesta automática"></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">No repetir el saludo antes de (horas)</label>
              <input
                type="number" min="0" max="720" step="1"
                className="form-control" style={{ maxWidth: 140 }}
                value={autoReplyOnceHours}
                onChange={(e) => setAutoReplyOnceHours(e.target.value)}
              />
              <div className="form-text">
                24 h por defecto: si el cliente escribe al día siguiente, se le vuelve a saludar. Con 0 se
                enviaría en <strong>cada</strong> mensaje (no recomendado).
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">O usar plantilla</label>
              <select
                className="form-select"
                value={autoReplyTemplateId}
                onChange={(e) => {
                  const val = e.target.value;
                  const tpl = whatsappTemplates.find((t) => t.id === val);
                  setAutoReplyTemplateId(val);
                  setAutoReplyTemplateType(tpl?.type || '');
                  setAutoReplyTemplateLang(tpl?.language || 'es');
                }}
              >
                <option value="">-- Sin plantilla --</option>
                {whatsappTemplates.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name} ({t.language}) {t.type === 'custom' ? '· Propia' : 'WABA'}
                  </option>
                ))}
              </select>
              <small className="text-muted">Si seleccionas una plantilla, se usará en vez del texto.</small>
            </div>
            <div className="mb-3">
              <label className="form-label">Idioma plantilla</label>
              <input className="form-control" value={autoReplyTemplateLang} onChange={(e) => setAutoReplyTemplateLang(e.target.value)} />
            </div>
            <button type="button" className="btn btn-outline-primary" onClick={onSaveAutoReply}>
              Guardar auto-respuesta
            </button>

            <hr />
            <h6>Mensaje de fuera de horario</h6>
            <p className="text-muted small mb-2">
              Si un cliente escribe fuera del horario de abajo, recibe este aviso en vez del saludo (nunca los
              dos). Con la IA en modo automático, fuera de horario <strong>no</strong> contesta sola: deja el
              borrador preparado para que lo revises al día siguiente.
            </p>
            <div className="form-check form-switch mb-2">
              <input
                className="form-check-input" type="checkbox" id="wabaOffHours"
                checked={!!offHoursEnabled}
                onChange={(e) => setOffHoursEnabled(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="wabaOffHours">Activar mensaje de fuera de horario</label>
            </div>
            <div className="mb-3">
              <textarea
                className="form-control" rows="3"
                value={offHoursText}
                onChange={(e) => setOffHoursText(e.target.value)}
                placeholder="Ej.: ¡Gracias por escribirnos! Ahora mismo estamos fuera de horario (L-V de 10:00 a 19:00). Te respondemos en cuanto abramos."
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">No repetir el aviso antes de (horas)</label>
              <input
                type="number" min="0" max="720" step="1"
                className="form-control" style={{ maxWidth: 140 }}
                value={offHoursOnceHours}
                onChange={(e) => setOffHoursOnceHours(e.target.value)}
              />
              <div className="form-text">12 h por defecto: si el cliente insiste esa misma noche, no se le repite.</div>
            </div>

            <label className="form-label fw-bold mb-1">Horario comercial</label>
            <p className="text-muted small mb-2">
              Marca los días que abres y sus horas (hora de Madrid). Puedes añadir un segundo tramo para el
              turno partido. Un día sin marcar cuenta como cerrado.
            </p>
            <div className="border rounded p-2 mb-2">
              {DIAS.map(({ n, label }) => {
                const list = ranges(n);
                const abierto = list.length > 0;
                return (
                  <div className="d-flex flex-wrap align-items-center gap-2 py-1 border-bottom" key={n}>
                    <div className="form-check mb-0" style={{ minWidth: 130 }}>
                      <input
                        className="form-check-input" type="checkbox" id={`bh-${n}`}
                        checked={abierto}
                        onChange={(e) => toggleDia(n, e.target.checked)}
                      />
                      <label className="form-check-label small" htmlFor={`bh-${n}`}>{label}</label>
                    </div>
                    {!abierto && <span className="text-muted small">Cerrado</span>}
                    {list.map((r, idx) => (
                      <div className="d-flex align-items-center gap-1" key={idx}>
                        <input
                          type="time" className="form-control form-control-sm" style={{ width: 110 }}
                          value={r.from} onChange={(e) => setHora(n, idx, 'from', e.target.value)}
                        />
                        <span className="small text-muted">a</span>
                        <input
                          type="time" className="form-control form-control-sm" style={{ width: 110 }}
                          value={r.to} onChange={(e) => setHora(n, idx, 'to', e.target.value)}
                        />
                        {idx > 0 && (
                          <button type="button" className="btn btn-sm btn-link text-danger p-0 ms-1" title="Quitar tramo" onClick={() => delTramo(n, idx)}>×</button>
                        )}
                      </div>
                    ))}
                    {abierto && list.length < 3 && (
                      <button type="button" className="btn btn-sm btn-link p-0 ms-auto text-decoration-none" onClick={() => addTramo(n)}>
                        + tramo
                      </button>
                    )}
                  </div>
                );
              })}
              <button type="button" className="btn btn-sm btn-link p-0 mt-2 text-decoration-none" onClick={aplicarLunesALaborables}>
                Aplicar el horario del lunes a martes-viernes
              </button>
            </div>
            <button type="button" className="btn btn-outline-primary" onClick={onSaveOffHours}>
              Guardar horario y aviso
            </button>

            <hr />
            <h6>Respuesta con IA (valores por defecto)</h6>
            <p className="text-muted small">
              Estos valores se aplican al crear una nueva conversación. Cada conversación puede ajustarlos desde su panel de opciones (prevalece la conversación).
            </p>
            <div className="form-check form-switch mb-2">
              <input
                className="form-check-input" type="checkbox" id="wabaAiDraft"
                checked={!!aiGenerateDraft}
                onChange={(e) => {
                  setAiGenerateDraft(e.target.checked);
                  if (!e.target.checked) setAiAutoSend(false);
                }}
              />
              <label className="form-check-label" htmlFor="wabaAiDraft">Generar borrador IA automáticamente al recibir un mensaje</label>
            </div>
            <div className="form-check form-switch mb-3">
              <input
                className="form-check-input" type="checkbox" id="wabaAiAutoSend"
                disabled={!aiGenerateDraft}
                checked={!!aiAutoSend && !!aiGenerateDraft}
                onChange={(e) => setAiAutoSend(e.target.checked && aiGenerateDraft)}
              />
              <label className="form-check-label" htmlFor="wabaAiAutoSend">Enviar respuesta IA automáticamente (sin revisión)</label>
            </div>
            <button type="button" className="btn btn-outline-primary" onClick={onSaveAiConfig}>
              Guardar ajustes de IA
            </button>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappSettingsModal;
